import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Lord of the dance",
  "description": "",
  "published": "2008-05-18T00:00:00.000Z",
  "redirect_from": ["/blog/lord-of-the-dance/swizec/111"],
  "categories": "review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You know, for the `}<em parentName="p">{`Greatest dance show on Earth`}</em>{` Lord of the dance sure was just a bunch of pixies prancing about on stage. Don't get me wrong, they're awesome dancers and some of the things they do with their blumin' feet are breath-taking (wonder if their ankles get sore after a while).`}</p>
    <p>{`In majority the show was a cacophony of sound and visuals, a spectacle, but sadly `}<strong parentName="p">{`just`}</strong>{` a spectacle. It was a football match of dance shows, a hockey game, a pop concert. There was much for the `}<em parentName="p">{`oooooo pretty`}</em>{` and very little for the mind to find. Whatever story there was, was fully transparent and no better than the majority of bollywood productions. Whatever there was of greatness and `}<em parentName="p">{`aaaaaahhh`}</em>{`'s was no better than a hollywood action flick.`}</p>
    <p>{`There was, however, one redeeming quality to the show. it was fun to watch. Sure it wasn't delicious and neither was it marvelous, but definitely something you can watch on a Saturday night with nothing else to do. Personally, though, I'd choose a nice walk around a gallery given the choice.`}</p>
    <p>{`The music was also pretty darn good, sucks you right in and makes your mind dance to their flute. Damn bastards have the algorithm fully figured out - just like all those serially produced pop princesses.`}</p>
    <p>{`All in all, it was fun, but I wouldn't go see it again, not for that kind of price.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      